// Packages
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';

// Components
import Routes from './components/Routes';
import AutoLogout from './components/AutoLogout';
import GlobalErrorModal from './components/GlobalErrorModal/GlobalErrorModal';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

// Hooks
import { useAuthSession } from './hooks/useAuthSession';
import { useAnalytics } from './hooks/useAnalytics';

// Utils
import { getErrorName } from './utils/errorUtils';

const App = () => {
  const { isAuthenticated } = useAuthSession();
  const { trackJsError } = useAnalytics();
  const navigate = useNavigate();

  // Catch All app errors
  const handleBoundaryError = (error: Error) => {
    trackJsError({
      appErrorType: 'application',
      msgFeatureName: 'unknown',
      appErrorCode: getErrorName(error) || 'unexpected',
      appErrorMessage: error.message,
    });
    navigate('/500');
  };

  return (
    <div className="App">
      <ErrorBoundary
        FallbackComponent={GlobalErrorModal}
        onError={handleBoundaryError}
      >
        <ScrollToTop>
          {isAuthenticated && <AutoLogout />}
          <Routes />
        </ScrollToTop>
      </ErrorBoundary>
    </div>
  );
};

export default App;
